import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routerMap.js'

Vue.use(VueRouter)

const whiteList = ['/login']

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (whiteList.indexOf(to.path) < 0) {
    const userId = sessionStorage.getItem('user_id')
    if (userId === null) {
      next('/login')
      return
    }
  }
  next()
})

export default router
